import { Minus, Plus } from "lucide-react";
import ITEMS from "@/data/faq.json";

// Questions fréquentes de l'accueil. Le texte vit dans src/data/faq.json : le
// même fichier sert au HTML pré-rendu pour les robots et aux données
// structurées FAQPage (scripts/prerendu.js). Une question à ajouter : là-bas.
// <details>/<summary> : accessibles au clavier et lisibles sans JavaScript.
const Faq = () => (
    <section id="faq" data-testid="faq-section" className="container-edit py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
            <div className="md:col-span-4">
                <p className="overline text-terracotta mb-4">Questions fréquentes</p>
                <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight mb-6">
                    Avant de te lancer.
                </h2>
                <p className="text-sm text-ink/60 leading-relaxed">
                    Une autre question ?{" "}
                    <a href="/contact" className="text-terracotta underline underline-offset-4 hover:text-ink">
                        Écris-nous
                    </a>
                    .
                </p>
            </div>
            <div className="md:col-span-8">
                <div className="divide-y divide-rule border-y border-rule">
                    {ITEMS.map((item, idx) => (
                        <details key={item.q} className="group py-5" data-testid={`faq-item-${idx}`}>
                            <summary
                                data-testid={`faq-q-${idx}`}
                                className="flex items-start justify-between gap-4 cursor-pointer list-none [&::-webkit-details-marker]:hidden"
                            >
                                <h3 className="font-serif text-xl md:text-2xl leading-tight text-ink group-hover:text-terracotta transition-colors">
                                    {item.q}
                                </h3>
                                <span className="flex-shrink-0 mt-1 text-ink/50 group-hover:text-terracotta transition-colors" aria-hidden="true">
                                    <Plus className="w-4 h-4 group-open:hidden" />
                                    <Minus className="w-4 h-4 hidden group-open:block" />
                                </span>
                            </summary>
                            <p data-testid={`faq-a-${idx}`} className="mt-4 text-base text-ink/75 leading-relaxed max-w-2xl">
                                {item.a}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Faq;
